module.exports = __webpack_public_path__ + "img/CLS-P-150.9e13c520.svg";